import {
  Alert,
  CRUDLayout,
  Pagination,
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
} from "components"
import {
  ButtonFilter,
  DataStatus,
  InputSearch
} from "components2"
import FileSaver from "file-saver"
import { Formik } from "formik"
import { debounce } from "lodash"
import { useEffect, useState } from "react"
import { Dropdown } from "react-bootstrap"
import { useQuery } from "react-query"
import { useLocation } from "react-router-dom"
import { DateConvert, DecimalConvert, RupiahConvert } from "utilities"
import { tableNumber } from "utilities2"
import {
  ExportButton,
  ModalFilter,
} from "./Comps"
import LaporanHPPApi from "./Service"

export const LaporanHPPList = ({ setNavbarTitle }) => {
  const { state } = useLocation()

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: "",
    variant: "primary",
  })

  const [filter, setFilter] = useState({
    q: "",
    page: 1,
    per_page: 10,
    tgl_realisasi_produksi_mulai: undefined,
    tgl_realisasi_produksi_selesai: undefined,
    tgl_produksi_mulai: undefined,
    tgl_produksi_selesai: undefined,
    tgl_hpp_mulai: undefined,
    tgl_hpp_selesai: undefined,
    id_barang_jadi: undefined,
    id_unit_produksi: undefined,
    active: false,
  })

  const [modalFilter, setModalFilter] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)

  const getLaporanHPP = useQuery(["laporan_hpp", "list", filter], () =>
    LaporanHPPApi.getList(filter)
  )

  const searchHandler = (e) => {
    const searchKey = e.target.value ? e.target.value : undefined

    setFilter({
      ...filter,
      q: searchKey,
      page: 1,
    })
    setAlertConfig({
      show: searchKey ? true : false,
      variant: "primary",
      text: "Hasil dari pencarian: " + searchKey,
    })
  }

  const onFilterButtonClickkHandler = () => setModalFilter(!modalFilter)

  const onPaginationChange = ({ selected }) =>
    setFilter({ ...filter, page: selected + 1 })

  const onPaginationDataLengthChange = (e) =>
    setFilter({ ...filter, page: 1, per_page: e.target.value })

  const checkAlert = () => {
    if (state) {
      if (state.alert) {
        setAlertConfig({
          show: state?.alert?.show,
          text: state?.alert?.text,
          variant: state?.alert?.variant,
        })
      }
    }
  }

  // FORM VALUES FILTER
  const formInitialValuesFilter = {
    tgl_realisasi_produksi_mulai: filter?.tgl_realisasi_produksi_mulai,
    tgl_realisasi_produksi_selesai: filter?.tgl_realisasi_produksi_selesai,
    tgl_produksi_mulai: filter?.tgl_produksi_mulai,
    tgl_produksi_selesai: filter?.tgl_produksi_selesai,
    tgl_hpp_mulai: filter?.tgl_hpp_mulai,
    tgl_hpp_selesai: filter?.tgl_hpp_selesai,
    id_barang_jadi: filter?.id_barang_jadi,
    id_unit_produksi: filter?.id_unit_produksi,
  }

  const formSubmitHandlerFilter = (values) => {
    const checkActive = Boolean(Object.values(values).filter((val) => val !== undefined && val !== null).length > 0)

    setFilter({
      ...filter,
      ...values,
      active: checkActive,
      page: 1,
    })
    onFilterButtonClickkHandler()
  }

  const exportData = (tipe) => {
    setLoadingExport(true)

    LaporanHPPApi.export({ ...filter, tipe })
      .then((res) => {
        const data = res.data.data
        FileSaver.saveAs(data, data)
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Export Data gagal",
        })
      })
      .finally(() => setLoadingExport(false))
  }

  useEffect(() => {
    setNavbarTitle("Laporan HPP")
    checkAlert()
  }, [])

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={debounce(searchHandler, 700)}
              className="mr-2"
            />
            <ButtonFilter
              size="sm"
              className="text-nowrap mr-2"
              onClick={onFilterButtonClickkHandler}
              active={filter?.active}
            />
            <ExportButton loading={loadingExport}>
              <Dropdown.Item onClick={() => exportData("excel")}>
                Excel (.xlsx)
              </Dropdown.Item>
            </ExportButton>
          </div>
        </CRUDLayout.HeadSearchSection>
      </CRUDLayout.Head>

      {getLaporanHPP.isFetching || getLaporanHPP.isError ? (
        <DataStatus
          loading={getLaporanHPP.isFetching}
          text={
            getLaporanHPP.isFetching ? "Memuat . . ." : "Data gagal dimuat"
          }
        />
      ) : (
        <>
          <Alert
            show={alertConfig?.show}
            text={alertConfig?.text}
            variant={alertConfig?.variant}
            showCloseButton
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          <div className="mt-2">
            <small className="font-weight-bold">List Data HPP</small>
          </div>
          <Table responsive>
            <THead>
              <Tr>
                <ThFixed rowSpan={2}>No.</ThFixed>
                <ThFixed rowSpan={2} className="text-nowrap">
                  Informasi Realisasi Produksi
                </ThFixed>
                <ThFixed rowSpan={2} className="text-nowrap">
                  Informasi Produksi
                </ThFixed>
                <ThFixed rowSpan={2} className="text-nowrap">
                  Informasi HPP
                </ThFixed>
                <Th rowSpan={2} className="text-nowrap">
                  Barang Jadi
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  Qty. Realisasi
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  Unit Produksi
                </Th>
                <Th colSpan={5} className="text-nowrap">
                  BDP
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  Total BDP
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  Total HPP
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  COA Debet HPP
                </Th>
                <Th rowSpan={2} className="text-nowrap">
                  COA Kredit HPP
                </Th>
              </Tr>
              <Tr>
                <Th className="text-nowrap">Bahan</Th>
                <Th className="text-nowrap">Upah</Th>
                <Th className="text-nowrap">Alat Mesin</Th>
                <Th className="text-nowrap">Subkon</Th>
                <Th className="text-nowrap">Overhead</Th>
              </Tr>
            </THead>
            <TBody>
              {getLaporanHPP?.data?.data?.length > 0 ? (
                getLaporanHPP?.data?.data?.map((e, index) => (
                  <Tr key={index}>
                    <TdFixed textCenter>
                      {tableNumber({
                        pageCurrent: filter.page,
                        dataLength: filter.per_page,
                        index,
                      })}
                    </TdFixed>
                    <TdFixed className="text-nowrap">
                      <div>
                        {e?.tgl_realisasi_produksi
                          ? DateConvert(new Date(e?.tgl_realisasi_produksi))
                            .defaultDMY
                          : "-"}
                      </div>
                      <div>{e?.no_realisasi_produksi ?? "-"}</div>
                    </TdFixed>
                    <TdFixed className="text-nowrap">
                      <div>
                        {e?.tgl_jobmix
                          ? DateConvert(new Date(e?.tgl_jobmix)).defaultDMY
                          : "-"}
                      </div>
                      <div>{e?.no_jobmix ?? "-"}</div>
                    </TdFixed>
                    <TdFixed className="text-nowrap">
                      <div>
                        {e?.tgl_hpp
                          ? DateConvert(new Date(e?.tgl_hpp)).defaultDMY
                          : "-"}
                      </div>
                      <div>{e?.no_hpp ?? "-"}</div>
                    </TdFixed>
                    <Td className="text-nowrap">{e?.nama_item ?? "-"}</Td>
                    <Td className="text-nowrap">
                      {`${DecimalConvert(parseFloat(e?.qty_realisasi_produksi ?? 0)).getWithComa} ${e?.kode_satuan ?? ""}`}
                    </Td>
                    <Td className="text-nowrap">
                      {e?.nama_unit_produksi ?? "-"}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_bahan ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_upah ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_alat_mesin ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_subkon ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_overhead ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.total_bdp ?? 0).toString()).getWithComa}
                    </Td>
                    <Td textRight className="text-nowrap">
                      {RupiahConvert(parseFloat(e?.jumlah ?? 0).toString()).getWithComa}
                    </Td>
                    <Td className="text-nowrap">
                      {`${e?.nomor_akun_debet ?? "-"} - ${e?.nama_akun_debet ?? "-"}`}
                    </Td>
                    <Td className="text-nowrap">
                      {`${e?.nomor_akun_kredit ?? "-"} - ${e?.nama_akun_kredit ?? "-"}`}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={16}>
                    <DataStatus text="Tidak ada data" />
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
          <Pagination
            dataLength={filter?.per_page}
            dataNumber={filter?.page * filter?.per_page - filter?.per_page + 1}
            dataPage={
              getLaporanHPP?.data?.data_count < filter?.per_page
                ? getLaporanHPP?.data?.data_count
                : filter?.page * filter?.per_page
            }
            dataCount={getLaporanHPP?.data?.data_count}
            currentPage={filter?.page}
            totalPage={getLaporanHPP?.data?.total_page}
            onPaginationChange={onPaginationChange}
            onDataLengthChange={onPaginationDataLengthChange}
          />
        </>
      )}

      {modalFilter && (
        <Formik
          enableReinitialize
          initialValues={formInitialValuesFilter}
          onSubmit={formSubmitHandlerFilter}
        >
          <ModalFilter toggle={onFilterButtonClickkHandler} />
        </Formik>
      )}
    </CRUDLayout>
  )
}
